import * as React from 'react';
import {ConfirmModal} from '../../confirm-modal';

interface ISessionEndInterviewProps {
    endInterview: () => void;
    swapRoles?: () => void;
    interviewTypeSwapRoles?: boolean;
    skipConfirm?: boolean;
}

interface ISessionEndInterviewState {
  endInterviewConfirmModalShown: boolean;
}

export class SessionEndInterview extends React.Component<ISessionEndInterviewProps, ISessionEndInterviewState> {
  public state: ISessionEndInterviewState = {
    endInterviewConfirmModalShown: false,
  };

  public render(): React.ReactElement<any> {
    const {endInterviewConfirmModalShown} = this.state;
    const {endInterview, interviewTypeSwapRoles, skipConfirm} = this.props;
    const confirmText = interviewTypeSwapRoles ? 'Or did' : 'Did'

    return (
      <div className={'session-end-interview'}>
        <button
          className={'btn btn_dark-red'}
          onClick={skipConfirm ? endInterview : this.showEndInterviewConfirmModal}
        >
          <span className={'icon fa fa-stop-circle'} />
          <span className={'btn__label btn__label_left-blank'}>End Session</span>
        </button>

        <ConfirmModal
          isOpen={endInterviewConfirmModalShown}
          title={'WAIT! Read this first'}
          onClose={this.closeEndInterviewConfirmModal}
          rightButtonText='End session'
        >
          <p className={'confirm-modal-component__content'}>
            Ending this session is final! After leaving this session,
            you will not be able to return to it.

            {interviewTypeSwapRoles && (
              <>
                {' '}Did you mean instead to
                {' '}<a className={'confirm-modal-component__link'} onClick={this.swapRoleFromConfirmModal}>
                SWAP ROLES
              </a>?
              </>
            )}
          </p>
          <p className={'confirm-modal-component__content'}>{confirmText} you mean to end the session?</p>
        </ConfirmModal>
      </div>
    );
  }

  private showEndInterviewConfirmModal = (): void => {
    this.setState({endInterviewConfirmModalShown: true});
  };

  private closeEndInterviewConfirmModal = (result: boolean): void => {
    this.setState({endInterviewConfirmModalShown: false});
    if (result) {
      this.props.endInterview();
    }
  };

  private swapRoleFromConfirmModal = (): void => {
    this.setState({endInterviewConfirmModalShown: false});
    this.props.swapRoles();
  };
}
